import { render, staticRenderFns } from "./PopupSearchProject.vue?vue&type=template&id=9fa7e7a0&scoped=true&"
import script from "./PopupSearchProject.vue?vue&type=script&lang=js&"
export * from "./PopupSearchProject.vue?vue&type=script&lang=js&"
import style0 from "./PopupSearchProject.vue?vue&type=style&index=0&id=9fa7e7a0&prod&lang=scss&"
import style1 from "./PopupSearchProject.vue?vue&type=style&index=1&id=9fa7e7a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa7e7a0",
  null
  
)

export default component.exports